import { Box, TableCell as MuiTableCell, Tooltip } from '@mui/material';
import React, { memo, forwardRef } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { DoDisturbAlt } from '@mui/icons-material';

// ✅ Forward ref so Tooltip works directly on the cell
export const CustomTableCell = forwardRef(({ children, ...props }, ref) => (
  <MuiTableCell ref={ref} {...props}>
    {children}
  </MuiTableCell>
));

CustomTableCell.displayName = 'CustomTableCell';

export const TableCell = memo(({ title = '', placement = "top", children, ...props }) => {
  const tooltipContent = (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "2px" }}>
      {title 
        ? <DoDisturbAlt sx={{ fontSize: "15px" }} />
        : <CancelIcon sx={{ fontSize: "15px" }} />}
      {title}
    </Box>
  );

  const cellContent = (
    <CustomTableCell {...props}>
      {children || '\u00A0'}
    </CustomTableCell>
  );

  return title ? (
    <Tooltip
      followCursor
      title={tooltipContent}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'white',
            color: 'red',
            border: "solid 1px gray"
          },
        },
      }}
    >
      {cellContent}
    </Tooltip>
  ) : (
    cellContent
  );
});

TableCell.displayName = 'TableCell';
